//copyright itestra 2016
import {
    Component,
    OnInit,
    AfterViewInit,
    EventEmitter,
    Output,
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import * as moment from "moment";

import { ValidatableComponent } from "../components/base.component";
import {
    Customer,
    Individual,
    Company,
    Address,
    isIndividual,
    isCompany,
    ConsultationProcess,
} from "../services/consultation.service";
import { Strings as Constants, CustomerType } from "../app.constants";
import {
    Salutation,
    TitleOfNobility,
    AcademicDegree,
    NameParticle,
    NameSuffix,
    LegalForm,
    Country,
    SalutationSelector,
} from "../data/model";
import { RootState } from "../store/root";
import { stateBuilder } from "../store/utils";
import { CustomerValidity } from "../store/validity/state";
import { PersistenceService } from "../store/model/persistence.service";
import {
    companySalutation,
    individualSalutation,
    createIndividual,
    createCompany,
    createAddress,
} from "../data/model-utils";
import { assert } from "../utils/debug";
import { ZASConstants } from "../data/model.constants";

@Component({
    selector: "zbd-customer",
    templateUrl: "customer.component.html",
})
export class CustomerComponent {
    state$: Observable<LocalState>;
    validity$: Observable<CustomerValidity>;

    Constants = Constants;
    ZASConstants = ZASConstants;

    getKeys = Object.keys;
    isIndividual = isIndividual;
    isCompany = isCompany;

    moment = moment;

    constructor(
        public persistence: PersistenceService,
        store: Store<RootState>,
    ) {
        this.state$ = LocalState.create(store);
        this.validity$ = store.select<CustomerValidity>(
            (s) => s.validity.customer,
        );
    }

    salutationUpdateFn(cp: ConsultationProcess) {
        return (
            customer: Individual | Company,
            property: keyof Customer,
            value: string,
        ) => {
            this.persistence.setCustomerType(companySalutation(value), value);
        };
    }

    customerUpdateFn(customer: Customer) {
        if (isIndividual(customer)) {
            return this.persistence.updateIndividual;
        } else if (isCompany(customer)) {
            return this.persistence.updateCompany;
        }
        assert(
            false,
            `Customer is of unknown type: ${JSON.stringify(customer)}`,
        );
        return undefined;
    }

    isLocked(customer: Customer): boolean {
        return customer.ExternalId != null;
    }

    isSalutationLocked(customer: Customer): boolean {
        return (
            !!ZASConstants.SalutationSelectorTable[customer.Salutation] &&
            this.isLocked(customer)
        );
    }
}

class LocalState {
    consultationProcess: ConsultationProcess;
    customer: Customer;
    address: Address;

    static create(store: Store<RootState>): Observable<LocalState> {
        return stateBuilder(store, new LocalState())
            .apply("consultationProcess", (s) => s.model.ConsultationProcess)
            .apply("customer", (s) => s.model.ConsultationProcess.Customer)
            .apply(
                "address",
                (s) => s.model.ConsultationProcess.Customer.Address,
            ).state$;
    }
}
